import Admin from "../Admin";
import React from "react";
import CardAdminDistributionReasonGeneral from "../../../Component/Card/Admin/DistributionReason/CardAdminDistributionReasonGeneral";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUISaveButton from "@mui/icons-material/Save";
import Menu from "../../../Component/Menu";
import DialogConfirm from "../../../Component/Dialog/DialogConfirm";
import MUIMenuItem from "@mui/material/MenuItem";
import MUIListItemIcon from "@mui/material/ListItemIcon";

import Validator from "../../../Utility/Validator";

import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import DistributionReasonService from "../../../Seating/Security/DistributionReasonService/distributionReasonService";
import DistributionReason from "../../../Utility/Crud/DistributionReason";

export default class AdminDistributionReasonCreateEdit extends Admin {
  constructor(props) {
    super(props);

    this.state.distributionReason = null;
    this.state.isProcessing = false;
    this.state.isUpdate = !!props.match.params.id;
    this.state.confirmDialogOpen = false;
    this.state.validationIssues = {};
  }

  /**
   * Set the distributionReason in the state.
   */
  afterComponentDidMount() {
    const distributionReasonId = this.props.match.params.id
      ? +this.props.match.params.id
      : null;

    if (distributionReasonId !== null) {
      const distributionReason =
        this.context.distributionReasonsIndexed[distributionReasonId];
      this.setState({
        distributionReason: distributionReason,
      });
    }
  }

  /**
   * Creates the distributionReason with the current properties in state.distributionReason.
   */
  async createDistributionReason() {
    this.setState({
      isProcessing: true,
    });

    return DistributionReasonService.createDistributionReason(
      this.state.distributionReason,
    )
      .then((distributionReason) => {
        this.context.updateIndexed(
          "distributionReasonsIndexed",
          distributionReason,
        );
        this.props.history.goBack();
        NotistackEnqueueSnackbar("Distribution Reason created successfully!", {
          variant: "success",
        });
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar(
          "Oh no! There was an error creating a new Distribution Reason.",
          { variant: "error" },
        );
        this.setState({
          isProcessing: false,
        });
      });
  }

  /**
   * Updates the distributionReason with the current properties in state.distributionReason.
   */
  async updateDistributionReason() {
    this.setState({
      isProcessing: true,
    });

    return DistributionReasonService.updateDistributionReason(
      this.state.distributionReason,
    )
      .then((distributionReason) => {
        this.context.updateIndexed(
          "distributionReasonsIndexed",
          distributionReason,
        );
        this.props.history.goBack();
        NotistackEnqueueSnackbar("Distribution Reason updated successfully!", {
          variant: "success",
        });
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar(
          "Oh no! There was an error updating the Distribution Reason.",
          { variant: "error" },
        );
        this.setState({
          isProcessing: false,
        });
      });
  }

  async deleteDistributionReason() {
    this.setState({
      isProcessing: true,
    });

    return DistributionReasonService.deleteDistributionReason(
      this.state.distributionReason.id,
    )
      .then(() => {
        this.context.deleteIndexed(
          "distributionReasonsIndexed",
          this.state.distributionReason.id,
        );
        this.props.history.goBack();
        NotistackEnqueueSnackbar("Distribution Reason deleted successfully!", {
          variant: "success",
        });
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar(
          "Oh no! There was an error deleting the Distribution Reason.",
          { variant: "error" },
        );
        this.setState({
          confirmDialogOpen: false,
        });
      });
  }

  /**
   * Render the content.
   */
  renderContent() {
    const handleChange = (distributionReason) => {
      this.setState((prevState) => ({
        distributionReason: {
          ...prevState.distributionReason,
          ...distributionReason,
        },
      }));
    };

    return (
      <>
        <CardAdminDistributionReasonGeneral
          distributionReason={this.state.distributionReason}
          onChange={handleChange.bind(this)}
          validationIssues={this.state.validationIssues}
        />
        <DialogConfirm
          open={this.state.confirmDialogOpen}
          onClose={() => this.setState({ confirmDialogOpen: false })}
          onConfirm={() => this.deleteDistributionReason()}
          text="Are you sure you want to delete this distribution reason? This cannot be undone."
          header="Delete Distribution Reason"
          loading={this.state.isProcessing}
        />
      </>
    );
  }

  /**
   * Render the header.
   */
  renderHeader() {
    let title;
    let subtitle;
    const buttonText = this.state.isUpdate ? "Save" : "Create";

    if (!this.state.isUpdate) {
      title = "Create Distribution Reason";
      subtitle = null;
    } else {
      title = "Edit Distribution Reason";
      subtitle =
        this.state.distributionReason &&
        DistributionReason.getDisplayName(this.state.distributionReason) +
          " • " +
          this.state.distributionReason.id;
    }

    const handleClickBack = () => {
      this.props.history.goBack();
    };

    const handleClickSave = () => {
      const validationIssues = Validator.validate(
        this.state.distributionReason,
        {
          code: {
            required: true,
          },
          distributionReasonTypeTermId: {
            required: true,
          },
        },
      );

      this.setState({
        validationIssues: validationIssues,
      });

      if (Object.keys(validationIssues).length === 0) {
        if (this.state.isUpdate) {
          this.updateDistributionReason();
        } else {
          this.createDistributionReason();
        }
      } else {
        NotistackEnqueueSnackbar("Please correct the displayed issues.", {
          variant: "error",
        });
      }
    };

    const handleDelete = () => {
      this.setState({
        confirmDialogOpen: true,
      });
    };

    const buttons = [
      <MUIButton onClick={handleClickBack}>Back</MUIButton>,
      <MUIButton
        loading={this.state.isProcessing}
        loadingPosition="start"
        onClick={handleClickSave}
        variant="contained"
        startIcon={<MUISaveButton />}
      >
        {buttonText}
      </MUIButton>,
    ];

    if (this.state.isUpdate) {
      const menuItems = [
        <MUIMenuItem onClick={handleDelete}>
          <MUIListItemIcon>
            <MUIDeleteIcon fontSize="small" />
          </MUIListItemIcon>
          Delete
        </MUIMenuItem>,
      ];
      buttons.push(<Menu menuItems={menuItems} />);
    }

    return <PageHeader title={title} subtitle={subtitle} buttons={buttons} />;
  }
}
